module.exports = __webpack_public_path__ + "img/ico_barley_01.01c18bec.svg";